module.exports = __webpack_public_path__ + "static/media/Finance.431fde67.png";